import { TextContentElement } from '@deltek/specification-client/core/Models/textContentElement'
import { useTreeViewStyles } from 'components/WorkspaceEditor/styles/useTreeViewStyles'
import React from 'react'
import { NodeOrder } from './NodeOrder'
import { PlainText } from './PlainText/PlainText'
import { SelectionOption } from './SelectionOption'

export const Hyperlink = React.memo<{
    contentItem: Partial<TextContentElement>
    isKeyedHyperlink: boolean
    itemOrder?: string
}>(({ contentItem, isKeyedHyperlink, itemOrder }) => {
    const classNames = useTreeViewStyles()

    return (
        <>
            {isKeyedHyperlink ? (
                <div data-testid="option-item" style={{ display: 'inline' }}>
                    <NodeOrder itemOrder={itemOrder || ''} />
                    <PlainText
                        contentItem={contentItem}
                        classes={classNames.paragraphTypography}
                    />
                </div>
            ) : (
                <SelectionOption contentItem={contentItem} />
            )}
        </>
    )
})
